// add to basket form
var updateInputUnits = function(select, updateVal){
    var input = select.siblings('input');
    var packSize = input.data('pack_size');
    var currentQty = input.val();
    if(select.val() == 'single'){
        input.attr('min', packSize).attr('step', packSize);
        if(updateVal){
            currentQty = Math.ceil(currentQty);
            input.val(packSize * currentQty);
        }
    }else{
        input.attr('min', 1).attr('step', 1);
        if(updateVal){
            input.val(Math.ceil(currentQty / packSize));
        }
    }
};

$(document).on('change', '.unit-select', function(e){
    updateInputUnits($(this), true);
});

$('.unit-select').each(function(index){
    updateInputUnits($(this), false);
});

$(document).on('click', '#customer-filter-form', function(e){
    $(this).submit();
});
